import ListAlt from "@material-ui/icons/ListAlt";
import goldIcon from "../../../assets/img/gold.png";
import diamondIcon from "../../../assets/img/diamond.png";
import branchIcon from "../../../assets/img/hub.png";
import loanIcon from "../../../assets/img/signing.png";
import stateIcon from "../../../assets/img/museum.png";
import roleIcon from "../../../assets/img/user.png";
import structureIcon from "../../../assets/img/structure.png";
import hierarchyIcon from "../../../assets/img/diagram.png";
import sanctionIcon from "../../../assets/img/document.png";
import pincodeIcon from "../../../assets/img/location.png";
import userIcon from "../../../assets/img/add-user.png";
import Standard from "../../../assets/img/deduction.png";
import Notice from "../../../assets/img/board.png";
import Register from "../../../assets/img/register.png";
import Packet from "../../../assets/img/packages.png";
import Lender from "../../../assets/img/debt.png";
import Ornament from "../../../assets/img/knowledge.png";
import Profile from "../../../assets/img/profile.png";
import Relationship from "../../../assets/img/relationship.png";
import Discrepancy from "../../../assets/img/discrepancy.png";
import Risk from "../../../assets/img/risk.png";
import details from "../../../assets/constants/config/config";
import { masterNames } from "assets/properties/properties";
const SidebarLinks = [
    {
      name: masterNames?.masterList,
      icon: ListAlt,
      children: [
  {
    name: masterNames?.goldRateMaster,
    code: "GOLDRATE",
    url: "/coreservice/gold-rates",
    icon: goldIcon,
  },
  {
    name: masterNames?.silverRateMaster,
    code: "SILVER_RATE",
    url: "/coreservice/silverRate",
    icon: goldIcon,
  },
  {
    name: masterNames?.diamondMaster,
    code: "DIAMOND_MASTER",
    url: "/coreservice/diamondMaster",
    icon: diamondIcon,
  },
  {
    name: masterNames?.branchesMaster,
    code: "BRANCHES",
    url: "/coreservice/branches",
    icon: branchIcon,
  },
  {
    name: masterNames?.pincodesMaster,
    code: "PINCODES",
    url: "/coreservice/pincodes",
    icon: pincodeIcon,
  },
  {
    name: masterNames?.loanSchemeMaster,
    code: "LOANSCHEME",
    url: "/coreservice/loanScheme",
    icon: loanIcon,
  },
  {
    name: masterNames?.inviteUserMaster,
    code: "INVITEUSER",
    url: "/coreservice/user-roles",
    icon: userIcon,
  },
  {
    name: masterNames?.stateMaster,
    code: "STATE",
    url: "/coreservice/state",
    icon: stateIcon,
  },
  {
    name:masterNames?.roleMaster,
    code:"ROLE",
    url: "/coreservice/roles",
    icon: roleIcon,
  },
  {
    name:masterNames?.designationMaster,
    code:"DESIGNATION",
    url: "/coreservice/designation",
    icon: roleIcon,
  },
  {
    name: masterNames?.structureMaster,
    code: "STRUCTURE",
    url: "/coreservice/structure",
    icon: structureIcon,
  },
  {
    name: masterNames?.hierarchyMaster,
    code: "HIERARCHY",
    url: "/coreservice/hierarchy",
    icon: hierarchyIcon,
  },
  {
    name: masterNames?.ornamentMaster,
    code: "ORNAMENT",
    url: "/coreservice/ornament",
    icon: Ornament,
  },
  {
    name: masterNames?.standardDeductionMaster,
    code: "STANDARDDEDUCTION",
    url: "/coreservice/StandardDeduction",
    icon: Standard,
  },
  {
    name: masterNames?.noticeBoardMaster,
    code: "NOTICEBOARD",
    url: "/coreservice/NoticeBoard",
    icon: Notice,
  },
  {
    name: masterNames?.registerMaster,
    code: "REGISTER",
    url: "/coreservice/RegisterMaster",
    icon: Register,
  },
  {
    name: masterNames?.packetInventoryMaster,
    code: "PACKETINVENTORY",
    url: "/coreservice/PacketInventory",
    icon: Packet,
  },
  {
    name: masterNames?.lenderMaster,
    code: "LENDER",
    url: "/coreservice/Lender",
    icon: Lender,
  },
  {
    name: masterNames?.relationshipMaster,
    code: "RELATIONSHIP",
    url: "/coreservice/relationship",
    icon: Relationship,
  },
  {
    name: masterNames?.negativeProfileMaster,
    code: "NEGATIVEPROFILE",
    url: "/coreservice/DueDiligence",
    icon: Profile,
  },
    {
    name: masterNames?.negativeRegistry,
    code: "NEGATIVEREGISTRY",
    url: "/coreservice/NegativeRegistery",
    icon: Profile,
  },
  {
    name: masterNames?.discrepancyMaster,
    code: "DISCREPANCY",
    url: "/coreservice/Discrepancy",
    icon: Discrepancy,
  },
  {
    name: masterNames?.collateralValuationMaster,
    code: "COLLATERALVALUATION",
    url: "/coreservice/Collateral",
    icon: Discrepancy,
  },
  {
    name: masterNames?.riskCategoryMaster,
    code: "RISKCATEGORY",
    url: "/coreservice/riskCategoryTab",
    icon: Risk,
  },
  {
    name: masterNames?.insuranceMaster,
    code: "VAP",
    url: "",
    icon: Lender,
    children: [
      {
        name: masterNames?.inuranceMasterChild1,
        code: "VAP_SUMINSURED",
        url: "/coreservice/suminsured",
        icon: Lender,
  
      },
      {
        name: masterNames?.inuranceMasterChild2,
        code: "VAP_ELIGIBILITY",
        url: "/coreservice/InsuranceEligibility",
        icon: Lender,
  
      },
    ]
  },
  {
    name: masterNames?.thirdPartyMaster,
    code: "THIRDPARTY",
    url: "/coreservice/ThirdParty",
    icon: Discrepancy,
  },
  {
    name: masterNames?.holidayMaster,
    code: "HOLIDAY",
    url: "/coreservice/Holiday",
    icon: Discrepancy,
  },
  {
    name: masterNames?.glHeadMaster,
    code: "GLHEAD",
    url: "/coreservice/GLHead",
    icon: Discrepancy,
  },
  {
    name: masterNames?.whiteListIpMaster,
    code: "WHITELISTIP",
    url: "/coreservice/WhiteListIP",
    icon: Discrepancy,
  },
  {
    name: masterNames?.lendingMaster,
    code: "LENDING_PARTNER",
    url: "/coreservice/lendingpartner",
    icon: Lender,
  },
  {
    name: masterNames?.renewalTopUpValidation,
    code: "RENEWAL_TOP_UP_VALIDATION",
    url: "/coreservice/renewalTopUpValidation",
    icon: Risk,
  },
  {
    name: masterNames?.deviationMaster,
    code: "DEVIATION_MASTER",
    url: "/coreservice/deviation",
    icon: Risk,
  },
  {
    name: masterNames?.leadValidationMaster,
    code: "LEAD_VALIDTION_MASTER",
    url: "/coreservice/leadValidation",
    icon: Risk,
  },
  {
    name: masterNames?.masterCategoryList,
    code: "MASTER_CATEGORY",
    url: "/coreservice/MasterCategory",
    icon: Discrepancy,
  },
  {
    name: masterNames?.foirMaster,
    code: masterNames?.foirMasterCode,
    url: masterNames?.foirMasterUrl,
    icon: Risk,
  },
      ],
    },
  ];
  export default SidebarLinks;